import { render, staticRenderFns } from "./AmountButton.vue?vue&type=template&id=bf6c0164&"
import script from "./AmountButton.vue?vue&type=script&lang=js&"
export * from "./AmountButton.vue?vue&type=script&lang=js&"
import style0 from "./AmountButton.vue?vue&type=style&index=0&id=bf6c0164&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports